<template>
    <dash
        icon="fa fa-dollar"
        titulo="PAGAMENTOS DESPESA"
        subTitulo="FINALIZAÇÃO"
        @click.native="$router.push({ name: 'DespesasGerais_Finalizacao_Pagamentos' })"
        :qtd="qtd"
        :mostrarQtd="true"
        :loading="loading"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
    props: {
        qtd: {
            type: Number
        },

        loading: {
            type: Boolean
        }
    },

    components: {
        Dash
    },

    data() {
        return {}
    }
}
</script>